import React, { useState, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useAtom, useSetAtom } from 'jotai';
import useAPI from '../../api';
import SectionPage from '../../Components/Paper/SectionPage';
import RolesListItem from './Components/RolesListItem';
import RoleDialog from './Components/RoleDialog';
import { openSnackbarAdviseAtom, searchValuesAtom } from '../../Atoms';
import RolesFilters from './Components/RolesFilters';

const getRolesListItem = (data, onClick, userInfo) => (
  <RolesListItem
    key={data.id}
    data={data}
    onClick={onClick}
    userInfo={userInfo}
  />
);

const RoleManagementPage = function RoleManagementPage(userInfo) {
  const intl = useIntl();
  const API = useAPI();

  const setOpenSnackbarAdvise = useSetAtom(openSnackbarAdviseAtom);
  const [searchValues, setSearchValues] = useAtom(searchValuesAtom);
  const [roleDialog, setRoleDialog] = useState(null);
  const [roles, setRoles] = useState([]);
  const [title, setTitle] = useState('');

  const openEditRoleDialog = (roleData) => {
    setTitle(roleData.name);
    setRoleDialog(roleData);
  };

  useEffect(() => {
    API.getRoles(
      (res) => {
        setRoles(res);
      },
      () => {
        setOpenSnackbarAdvise({
          message: intl.messages.ROLES_LOADING_ERROR,
          severity: 'error',
        });
      }
    );
  }, []);

  /****/
  const handleSubmit = (data) => {
    API.setLicence(
      data,
      () => {
        setOpenSnackbarAdvise({
          message: intl.messages.LICENCE_EDITED_SUCCESSFULLY,
          severity: 'success',
        });
        setRoles((prev) =>
          prev.map((item) =>
            item.id === data.id
              ? {
                  ...item,
                  licences: data.licences,
                }
              : item
          )
        );
      },
      (err) => {
        setOpenSnackbarAdvise({
          message: `${intl.messages.ERROR}: ${
            err?.status ? `${err?.status} - ` : ''
          } ${intl.messages.EDITING_LICENCE_ERROR}`,
          severity: 'error',
        });
      }
    );
    setRoleDialog(null);
  };

  const filteredAndSortedUsers = useMemo(() => {
    if (!roles?.length) return [];

    if (searchValues?.searchBox) {
      const query = searchValues.searchBox.toUpperCase();
      return roles.filter(({ name }) => name?.toUpperCase().includes(query));
    }

    return roles;
  }, [searchValues, roles]);

  return (
    <>
      <SectionPage
        hideExportExcel
        hideFilters
        hideSorting
        sectionName="ROLES_MANAGEMENT"
        sectionSubName="LICENCES"
        customEntryFunction={(item) =>
          getRolesListItem(item, openEditRoleDialog, userInfo)
        }
        singlePageList={filteredAndSortedUsers}
        customFilters={
          <RolesFilters
            defaultValues={{
              searchBox: searchValues?.searchBox || '',
            }}
            onChangeFilters={(newSearchValues) => {
              setSearchValues((prev) => ({
                ...prev,
                ...newSearchValues,
              }));
            }}
          />
        }
      />
      <RoleDialog
        title={`${intl.messages.EDIT_LICENSE} ${title}`}
        onSubmit={handleSubmit}
        open={Boolean(roleDialog)}
        roleData={roleDialog}
        edit={roleDialog?.dialogType === 'EDIT'}
        close={() => {
          setRoleDialog(null);
        }}
      />
    </>
  );
};
export default RoleManagementPage;
